// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width: 360px){h3[data-v-387a5f55]{font-size:1.4rem}}\n", "",{"version":3,"sources":["webpack://src/components/common/PageTitle.vue"],"names":[],"mappings":"AAAA,0BAA0B,oBAAoB,gBAAgB,CAAC","sourcesContent":["@media (max-width: 360px){h3[data-v-387a5f55]{font-size:1.4rem}}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
